import { Modal, Table } from "react-bootstrap";
import { X, List } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedUserPop } from "../store/api/Users";

const ModalSelectedUserStatus = () => {
    const popStatus = useSelector(state => state.UserReducer.selectedUserPop);
    const dispatch = useDispatch();
    return (
        <Modal show={popStatus.show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#838fe8' }}><span><List color="white" size={22} />&nbsp;لیست کاربران</span><span onClick={() => dispatch(setSelectedUserPop({ show: false }))} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body >
                <hr style={{ marginBottom: 0 }} />
                {popStatus.userList &&
                    <div className="mt-1" style={{ maxHeight: "350px", overflowX: "hidden", overflowY: "scroll" }}>
                        <Table >
                            <thead>
                                <tr>
                                    <th style={{ width: "10px", padding: "0" }}></th>
                                    <th>نام کاربر</th>
                                    <th>خوانده شده</th>
                                    <th>انجام شده</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(popStatus.userList) && popStatus.userList.map((item, i) => {
                                    return (<tr key={i}>
                                        <td></td>
                                        <td>{item.RecipientName}</td>
                                        <td><input type="checkbox" readOnly checked={item.IsRead}/></td>
                                        <td><input type="checkbox" readOnly checked={item.IsDone}/></td>
                                    </tr>)
                                }
                                )}
                            </tbody>
                        </Table>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer style={{ direction: "ltr" }}>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalSelectedUserStatus;